<template>
  <div
    class="study-online-tab"
    v-if="item_requires.length && item_electives.length"
  >
    <ul class="class-tabs">
      <li @click="nessShow()" class="high-light">
        {{ $t("public.RequiredPlan") }}
      </li>
      <li @click="unNessShow()">{{ $t("public.OptionalPlan") }}</li>
    </ul>
    <div class="class-list">
      <ul class="ness-class">
        <mustStudy :list2="item_requires"></mustStudy>
      </ul>
      <ul class="un-ness-class">
        <selectStudy :list2="item_electives"></selectStudy>
      </ul>
    </div>
    <router-link
      :to="'/main/learning_camp?tabType=' + tabType"
      tag="p"
      class="ajax-more"
      >{{ $t("columnVideo.seeMore") }}</router-link
    >
  </div>
  <div v-else-if="item_requires.length && !item_electives.length">
    <study-online-tab3
      :requires="requires"
      :item_requires="item_requires"
    ></study-online-tab3>
  </div>
  <div v-else-if="!item_requires.length && item_electives.length">
    <study-online-tab4
      :electives="electives"
      :item_electives="item_electives"
    ></study-online-tab4>
  </div>
</template>
<script>
import StudyOnline3 from "views/studyonline/StudyOnline3.vue";
import StudyOnline4 from "views/studyonline/StudyOnline4.vue";
import mustStudy from "components/learningCamp/mustStudy.vue";
import selectStudy from "components/learningCamp/selectStudy.vue";
export default {
  name: "StudyOnlineTab",
  components: {
    "study-online-tab3": StudyOnline3,
    "study-online-tab4": StudyOnline4,
    mustStudy,
    selectStudy,
  },
  data() {
    return {
      // tabOne:"必修"
      // tabTwo:"选修",
      // tabOne: this.$t("public.RequiredPlan"),
      // tabTwo: this.$t("public.OptionalPlan"),
      itemOne: [],
      itemTwo: [],
      which: 1,
      tabType: 1,
    };
  },
  props: ["requires", "electives", "item_requires", "item_electives"],
  methods: {
    nessShow() {
      this.which = 1;
      this.tabType = 1;
      // this.niceData(this.which);
      $(".ness-class").css("display", "block");
      $(".un-ness-class").css("display", "none");
      $(".class-tabs")
        .find("li")
        .eq(0)
        .css("background", "#fff")
        .siblings()
        .css("background", "#f6f6f6");
    },
    unNessShow() {
      this.which = 2;
      this.tabType = 2;
      // this.niceData(this.which);
      $(".ness-class").css("display", "none");
      $(".un-ness-class").css("display", "block");
      $(".class-tabs")
        .find("li")
        .eq(1)
        .css("background", "#fff")
        .siblings()
        .css("background", "#f6f6f6");
    },
    niceData(num) {
      let _this = this;
      if (num == 1 && _this.itemOne.length > 0) return false;
      if (num == 2 && _this.itemTwo.length > 0) return false;
      let url = "index.php/mobile/trainplan/my-trainplan-list";
      let params = {
        auth_type: num,
        page: 1,
        size: 2,
        sys_id: localStorage.getItem("_sys_id"),
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        language: localStorage.getItem("_user_data_language"),
        not_start_except: 1,
        expire_except: 1,
      };
      _this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          var arr = res.data.result.data;
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].finish_progress == 100) {
              // 已完成
              arr[i].message = { whichShow: 1, limitDays: -1, mask: false };
            } else if (arr[i].is_overdue == 1) {
              // 已过期
              arr[i].message = { whichShow: 4, limitDays: -1, mask: true };
            } else if (arr[i].tag_bottom) {
              // 剩
              arr[i].message = {
                whichShow: 3,
                limitDays: arr[i].tag_bottom,
                mask: false,
              };
            } else {
              // 未完成
              arr[i].message = { whichShow: 2, limitDays: -1, mask: false };
            }
          }
          if (num == 2) {
            _this.itemTwo = arr;
          } else {
            _this.itemOne = arr;
          }
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.study-online-tab {
  width: 100%;
  margin-bottom: 0.22rem;
  background: #fff;
  .class-tabs {
    width: 100%;
    overflow: hidden;
    background: #f6f6f6;
    li {
      width: 50%;
      height: 0.72rem;
      background: #f6f6f6;
      line-height: 0.72rem;
      font-size: 0.32rem;
      text-align: center;
      float: left;
      &.high-light {
        background: #fff;
      }
    }
  }
  .class-list {
    width: 100%;
    ul {
      width: 100%;
      &.ness-class {
        display: block;
      }
      &.un-ness-class {
        display: none;
      }
      li {
        padding: 0.35rem 0.18rem 0.26rem 0.28rem;
        display: flex;
        .class-list-box-left {
          display: flex;
          flex-direction: column;
          margin-right: 0.29rem;
          img {
            width: 2.8rem;
            height: 1.59rem;
          }
          div {
            margin-top: 0.07rem;
            width: 2.8rem;
            height: 0.1rem;
            border-radius: 0.05rem;
            background: #e2e4e6;
            position: relative;
            span {
              position: absolute;
              display: block;
              height: 0.16rem;
              border-radius: 0.05rem;
              border: 0.01rem solid #d7d7d7;
              color: #252631;
              font-size: 0.1rem;
              top: -0.24rem;
              text-align: center;
              line-height: 0.16rem;
              background: #fff;
            }
          }
        }
        .class-list-box-right {
          width: 100%;
          padding-top: 0.2rem;
          position: relative;
          h5 {
            font-size: 0.26rem;
            font-weight: bold;
            color: #252631;
          }
          h6 {
            font-size: 0.18rem;
            height: 0.47rem;
            line-height: 0.47rem;
            color: #666;
          }
          p {
            height: 0.85rem;
            line-height: 0.85rem;
            font-size: 0.18rem;
            color: #005587;
          }
          div {
            position: absolute;
            right: 0;
            top: -0.16rem;
            width: 0.8rem;
            height: 0.65rem;
            padding-top: 0.2rem;
            border-radius: 100%;
            display: flex;
            flex-direction: column;
            font-size: 0.18rem;
            font-weight: bold;
            align-items: center;
            span {
              display: block;
              &:nth-child(2) {
                width: 0.26rem;
                height: 0.2rem;
              }
            }
            &.done {
              border: 0.01rem solid #4aa854;
              color: #4aa854;
              background: #fff;
              span:nth-child(2) {
                background: url("~@/assets/img/new/ok.png") no-repeat
                  center/contain;
              }
            }
            &.undone {
              border: 0.01rem solid #ecedee;
              background: #f7f8f9;
              color: #666;
            }
          }
        }
      }
    }
  }
  .ajax-more {
    height: 0.66rem;
    line-height: 0.66rem;
    text-align: center;
    font-size: 0.22rem;
    color: #005587;
    border-top: 0.01rem solid #d9ddde;
  }
}
</style>
